import { useState } from 'react';
import './App.css';



function Footer() {




    return(
        <div class="footerDiv">
                <div className='footerSubDiv'>
                    <h2>A Project by Group 3</h2>
                </div>
                <div className='footerSubDiv'>
                    <img src="../footerimg.png"></img>
                </div>
                <div className='footerSubDiv'>
                    <h2>Responsive Design</h2>
                </div>
            </div>
    );
}

export default Footer;